import { useCallback, useState } from 'react';

type Value = string | ((value: string) => string);

export default function useSessionStorage(key: string, defaultValue: string): [string, (value: Value) => void] {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.sessionStorage.getItem(key);

            return item ? item : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    const setValue = useCallback(
        (value: Value) => {
            try {
                const valueToStore = value instanceof Function ? value(storedValue) : value;
                if (valueToStore !== storedValue) {
                    setStoredValue(valueToStore);
                    window.sessionStorage.setItem(key, valueToStore);
                }
            } catch (error) {
                console.error(error);
            }
        },
        [key, storedValue]
    );

    return [storedValue, setValue];
}
